import Vue from 'vue';
import VueAxios from 'vue-axios';
import httpClient from '../utils/http_client';
import 'normalize.css';

Vue.use(VueAxios, httpClient);
Vue.axios.defaults.baseURL = '/api/';
